import React from 'react';
import { Container } from '@ui';
import { getDocumentStatus } from '@utils/documentVault';
import { VaultTableHeader } from './VaultTableHeader';
import { VaultTableRow } from './VaultTableRow';

export const VaultTable = ({ docs, statusLookup, density, onShowDetails }) => {
  return (
    <Container>
      <VaultTableHeader pageDocs={docs} />
      {docs.map((doc) => (
        <VaultTableRow
          key={doc.id}
          doc={doc}
          status={getDocumentStatus(doc, statusLookup)}
          density={density}
          onShowDetails={onShowDetails}
        />
      ))}
    </Container>
  );
};
